import { makeAutoObservable } from 'mobx';

class ConversationsStore {
  // TODO: Add conversations list state and actions here when needed

  constructor() {
    // NOTE: Store left intentionally minimal for now.
    // When we start implementing logic, add observables/actions as needed.
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

export default ConversationsStore;
